module.exports = __webpack_public_path__ + "img/ZG81_13.46a34c5c.jpg";